import { AttributeDataType, FilterOperator } from "../types";
import type { OperatorOption } from "../types";

// WOR-1295: Updated operator lists based on requirements
// TEXT (freetext): Default CONTAINS, show CONTAINS and IS_EMPTY
export const TEXT_OPERATORS: OperatorOption[] = [
  { label: "Contains", value: FilterOperator.CONTAINS },
  { label: "Is Empty", value: FilterOperator.IS_EMPTY },
];

// INT/FRACTION: Default IS, show IS, IS_NOT, IS_EMPTY, RANGE
export const NUMBER_OPERATORS: OperatorOption[] = [
  { label: "Is", value: FilterOperator.IS },
  { label: "Is Empty", value: FilterOperator.IS_EMPTY },
];

// DATETIME: Default RANGE, show RANGE and IS_EMPTY
export const DATETIME_OPERATORS: OperatorOption[] = [
  { label: "Range", value: FilterOperator.RANGE },
  { label: "Is Empty", value: FilterOperator.IS_EMPTY },
];

// BOOLEAN: Keep IS
export const BOOLEAN_OPERATORS: OperatorOption[] = [
  { label: "Is", value: FilterOperator.IS },
];

// FOREIGN_KEY (multiselect): Default IS, show IS, IS_NOT, IS_EMPTY
export const FOREIGN_KEY_OPERATORS: OperatorOption[] = [
  { label: "Is", value: FilterOperator.IS },
  { label: "Is Not", value: FilterOperator.IS_NOT },
  { label: "Is Empty", value: FilterOperator.IS_EMPTY },
];

export function getOperatorsForDataType(
  dataType: AttributeDataType
): OperatorOption[] {
  switch (dataType) {
    case AttributeDataType.FOREIGN_KEY:
      return FOREIGN_KEY_OPERATORS;
    case AttributeDataType.TEXT:
      return TEXT_OPERATORS;
    case AttributeDataType.INT:
    case AttributeDataType.FRACTION:
      return NUMBER_OPERATORS;
    case AttributeDataType.DATETIME:
      return DATETIME_OPERATORS;
    case AttributeDataType.BOOLEAN:
      return BOOLEAN_OPERATORS;
    default:
      return TEXT_OPERATORS;
  }
}

export function getOperatorLabel(operator: FilterOperator): string {
  switch (operator) {
    case FilterOperator.IS:
      return "Is";
    case FilterOperator.IS_NOT:
      return "Is Not";
    case FilterOperator.IS_EMPTY:
      return "Is Empty";
    case FilterOperator.CONTAINS:
      return "Contains";
    case FilterOperator.STARTS_WITH:
      return "Starts With";
    case FilterOperator.ENDS_WITH:
      return "Ends With";
    case FilterOperator.RANGE:
      return "Range";
    default:
      return "Unknown";
  }
}

/**
 * WOR-1295: Get default operator for a given data type
 * TEXT: CONTAINS
 * DATETIME: RANGE
 * FOREIGN_KEY, INT, FRACTION, BOOLEAN: IS
 */
export function getDefaultOperatorForDataType(
  dataType: AttributeDataType
): FilterOperator {
  switch (dataType) {
    case AttributeDataType.TEXT:
      return FilterOperator.CONTAINS;
    case AttributeDataType.DATETIME:
      return FilterOperator.RANGE;
    case AttributeDataType.FOREIGN_KEY:
    case AttributeDataType.INT:
    case AttributeDataType.FRACTION:
    case AttributeDataType.BOOLEAN:
    default:
      return FilterOperator.IS;
  }
}
